import { useCallback } from 'react';
import { selectUser } from '../../common/store/slices/auth.slice';

import { useAppSelector } from '../../common/hooks/redux';
import { isLocalhost } from './utils';
import { useModuleProjectContext } from 'common/contexts/useModuleProjectContext';
import { fullStoryIdentity } from 'common/utils/trackingIdentity';

declare global {
  interface Window {
    FS: any;
  }
}

export const useFullStory = () => {
  const user = useAppSelector(selectUser);
  const { activeProject } = useModuleProjectContext();

  const initiateFullStory = useCallback(() => {
    if (user.id && user.companyName && !isLocalhost()) {
      const { FS } = window;
      if (FS) {
        // #194: the shared person id once the API issues one, else today's hashid.
        FS('setIdentity', fullStoryIdentity(user, activeProject));
      }
    }
  }, [user, activeProject]);

  return { initiateFullStory };
};
